module.exports = __webpack_public_path__ + "static/media/paokvoice.92af84b7.png";